<template>
  <div>
    <template v-if="!isLoading">
      <PayPal
        v-if="showPaypal && env"
        :amount="amount"
        :currency="currency"
        :client="credentials"
        :env="env"
        @payment-authorized="handlePaymentAuthorized"
        @payment-completed="handlePaymentCompleted"
        @payment-cancelled="handlePaymentCancelled"
      />
      <div class="custom__paypal m-auto" v-else>
        <p>PayPal Checkout</p>
        <span>Booking overlapped</span>
      </div>
    </template>
    <Spinner v-else :theme="primary" />
  </div>
</template>

<script>
import axios from "@/helpers/axios";
import PayPal from "vue-paypal-checkout";
import Spinner from "@/components/Spinner";
import { filter } from "lodash";
import * as logger from "@/helpers/logger";

export default {
  components: {
    PayPal,
    Spinner
  },
  props: {
    amount: {
      type: [String],
      default: "0"
    },
    currency: {
      type: [String],
      default: "PHP"
    },
    invoice: {
      type: [Object]
    }
  },
  data() {
    return {
      credentials: {
        sandbox: null,
        production: null
      },
      showPaypal: false,
      env: null,
      isLoading: true
    };
  },
  async mounted() {
    await this.$store.dispatch("fetchOptions", "paymentoption");
    let newFiltered = filter(this.options, options => {
      return options.label == "Paypal";
    });
    if (this.options.length !== 0) {
      let active = filter(newFiltered[0].value.data, val => {
        return val.status === true;
      });
      if (active.length !== 0) {
        let paypalToken = active[0].value;
        this.credentials.sandbox = paypalToken;
        this.credentials.production = paypalToken;
        this.env = active[0].label === "Sandbox" ? "sandbox" : "production";
      }
    }
    await this.checkIfAvailable();
  },
  computed: {
    options() {
      return this.$store.state.concierge.optionsList.data;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    }
  },
  methods: {
    async checkIfAvailable() {
      this.isLoading = true;
      const orders = this.invoice.OrderPackages;
      var isavailable = true;
      for (var order of orders) {
        const id = order.Package.productId;
        await axios
          .get(
            `/products/${id}/availability?qp[start]=${order.startAt}&qp[end]=${order.endAt}&qp[op]=${order.id}`
          )
          .then(response => {
            const available = response.data.available;
            if (available === false) {
              isavailable = false;
            }
          });
      }
      this.showPaypal = isavailable;
      this.isLoading = false;
    },
    handlePaymentAuthorized(data) {
      logger.log("AUTHORIZED: ", data);
    },
    handlePaymentCompleted(data) {
      logger.info("COMPLETED: ", data);
      this.$emit("approved", data);
    },
    handlePaymentCancelled(data) {
      logger.warn("CANCELLED", data);
    }
  }
};
</script>

<style lang="scss" scoped>
.custom__paypal {
  pointer-events: none;
  width: 150px;
  line-height: 10px;
  text-align: center;
  p {
    padding: 5px 10px;
    font-size: 12px;
    background: #efefef;
    margin-bottom: 0;
    border-radius: 50px;
  }
  span {
    margin: 0;
    font-size: 10px;
  }
}
</style>
